<template>
  <div class="container">
    <div class="row justify-content-end mt-2">
      <!-- <div class="col-4"> -->
      <a :href="loginUrl" class="custom-button">
        <div class="custom-button-icon">
          <i class="fas fa-user"></i>
        </div>
        <div class="custom-button-text">
          XtrimPro
          <small>Iniciar sesión</small>
        </div>
      </a>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "Ingresar-Landing",
  components: {},

  data() {
    return {
      loading: true,
      isMobile: this.$isMobile,
    };
  },
  computed: {
    loginUrl() {
      const queryString = new URLSearchParams(this.$route.query).toString();
      return queryString ? `/login?${queryString}` : '/login';
    },
  },
  watch: {},

  activated() {},
  mounted() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
  methods: {},
};
</script>

<style scoped>
.custom-button {
  display: flex;
  align-items: center;
  background-color: white; /* Púrpura #800080 */
  /* Color púrpura */
  border: 3px solid #ffd700;
  /* Contorno amarillo */
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  padding: 10px 20px;
  color: white;
  font-family: Arial, sans-serif;
  font-weight: bold;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  transition: transform 0.2s ease;
}

.custom-button:hover {
  transform: scale(1.05);
}

.custom-button-icon {
  background-color: #800080; /* Púrpura #800080 */
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.custom-button-text {
  color: #800080;
  font-size: 16px;
  white-space: nowrap;
}

.custom-button-text small {
  display: block;
  font-size: 12px;
  color: #800080;
  font-weight: normal;
}

/* Media queries para responsive */
@media (max-width: 1024px) {
  .custom-button {
    padding: 8px 16px;
  }

  .custom-button-icon {
    width: 35px;
    height: 35px;
    margin-right: 8px;
  }

  .custom-button-text {
    font-size: 14px;
  }

  .custom-button-text small {
    font-size: 11px;
  }
}

@media (max-width: 900px) {
  .custom-button {
    padding: 7px 14px;
    border-width: 2px;
  }

  .custom-button-icon {
    width: 32px;
    height: 32px;
    margin-right: 7px;
  }

  .custom-button-text {
    font-size: 13px;
  }

  .custom-button-text small {
    font-size: 10px;
  }
}

@media (max-width: 790px) {
  .custom-button {
    padding: 6px 12px;
    border-width: 2px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }

  .custom-button-icon {
    width: 30px;
    height: 30px;
    margin-right: 6px;
  }

  .custom-button-text {
    font-size: 12px;
  }

  .custom-button-text small {
    font-size: 9px;
  }
}

@media (max-width: 600px) {
  .custom-button {
    padding: 5px 10px;
    border-width: 2px;
  }

  .custom-button-icon {
    width: 28px;
    height: 28px;
    margin-right: 5px;
  }

  .custom-button-text {
    font-size: 11px;
  }

  .custom-button-text small {
    font-size: 8px;
  }
}
</style>
